import React, { memo } from 'react'
import Skeleton from '../../../skeleton/Skeleton'

function InfoCount({ count, text, icon }) {
  return (
    <>
      <div
        className={
          'bg-light-blue dark:bg-slate-800 py-2 sm:py-4 px-2 sm:px-6 w-full rounded-2xl border border-light-gray dark:border-gray-700 shadow-info-count dark:shadow-none block mx-auto flex justify-between sm:flex-col'
        }
      >
        <div className="flex items-center">
          <i className={`${icon} hidden sm:inline-block text-3xl text-secondary ml-2`} />
          <span
            className={
              'inline-block font-medium text-base md:text-base lg:text-lg dark:text-amber-50'
            }
          >
            {text}
          </span>
        </div>
        <span className={'block mt-4 text-xxl md:text-5xl font-medium dark:text-amber-100'}>
          {count >= 0 ? count : <Skeleton />}
        </span>
      </div>
    </>
  )
}

export default memo(InfoCount)
